<template>
  <el-dialog title="设置折扣特权" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <p class="setemployee">为 业务{{employeename}} 设置个人特权折扣:</p>
      <el-form ref="form" :rules="rules" :model="formdata" label-width="100px">
        <el-form-item>
          <el-radio-group v-model="formdata.discount_type">
            <el-radio
              v-for="(item,index) in discounttype"
              :label="item.value"
              :key="index"
            >{{item.label}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="formdata.discount_type===1" prop="discount">
          <el-input type="text" class="w160" v-model="formdata.discount"></el-input>折
        </el-form-item>
        <el-form-item v-else>{{formdata.discount}}折</el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save('form')">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import api from "@/api.js";
import { discounttype } from "@/util/util.js";
export default {
  name: "settingsDiscountDialog",
  props: ["visible", "employeename", "employeeid", "discount_type", "discount"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  data() {
    return {
      discounttype: discounttype,
      dialogVisible: this.visible,
      formdata: {
        discount_type: this.discount_type,
        discount: this.discount
      },
      rules: {
        discount: [
          { required: true, message: "请输入折扣特权", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submitsave();
        } else {
          return false;
        }
      });
    },
    // 提交保存
    submitsave() {
      let params = {
        em_id: this.employeeid,
        discount_type: this.formdata.discount_type,
        discount: this.formdata.discount
      };
      this.axios
        .post(api.discount_set_employee, params)
        .then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: "设置成功",
            });
            this.$emit("setdiscountsucess");
            this.dialogVisible = false;
          } else {
          }
        })
        .catch(() => {});
    }
  }
};
</script>
<style scoped>
.setemployee {
  text-align: center;
}
</style>


